/**
 * Submits a form to the CEP API (a 201 response means success).
 * Each form key maps to the property_id of a form created in the CEP data
 * admin (https://cepdata.discoveryeducation.com/forms).
 *
 * The endpoint must have no trailing slash: /form/ redirects to plain http,
 * which a browser POST cannot follow.
 */
const API_URL = 'https://cepdata.discoveryeducation.com/api/v2/form';

const FORM_IDS = {
  schedulevisit: '6aea5b7370fd1e66fa0c1192',
  askexpert: '6aea5ddbd5d4b9c8560fe152',
};

const isPreviewHost = (hostname) =>
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  /^dev-.*\.pantheonsite\.io$/.test(hostname);

const submitForm = (formKey, fields) => {
  const propertyId = FORM_IDS[formKey];

  if (!propertyId) {
    // Not connected yet: only "succeed" on preview hosts so a real visitor
    // never sees a false confirmation.
    if (typeof window !== 'undefined' && isPreviewHost(window.location.hostname)) {
      console.info(`[submitForm] ${formKey} has no property_id (not sent)`, fields);
      return Promise.resolve();
    }
    return Promise.reject(new Error(`Form "${formKey}" is not connected yet.`));
  }

  return fetch(API_URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ property_id: propertyId, fields }),
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`Form submission failed with status ${response.status}`);
    }
  });
};

export default submitForm;
